/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { LayerPickerIconProps } from './iconUtilities';

export const PlayButtonIcon = memo(({ 
    backgroundFillColor = '#FFFFFF',
    symbolFillColor = '#666666',
    width = 18,
    height = 18
}: LayerPickerIconProps) =>
    <svg width={width} height={height} fill={backgroundFillColor} viewBox='0 0 15 17' id='ui-play'>
        <polygon
            id='play-Triangle-8'
            transform='translate(7.000000, 9.000000) rotate(90.000000) translate(-7.000000, -9.000000)'
            points='7 2 15 16 -1 16'
            fill={symbolFillColor}
        />
    </svg>
);